import { Component, ViewEncapsulation, Input, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { InventoryReference } from '../../../shared/models/InventoryReference';
import { SaveMode } from '../../../shared/enums/SaveMode';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { InventoryThresholdOverrideAlternative } from '@app/cp/shared/models/InventoryThresholdOverrideAlternative';
import { alignCenterIcon } from '@progress/kendo-svg-icons';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { v_InventoryBus } from '@app/cp/shared/models/v_InventoryBus';
import { ConfirmOutput } from '../../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../../shared/enums/CRUDActions';
import { MessageType } from '../../../shared/enums/MessageType';

@Component({
    selector: 'part-alternatives-thresholds',
    templateUrl: './part-alternatives-thresholds.component.html',
    styleUrls: ['./part-alternatives-thresholds.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PartAlternativesThresholdsComponent extends BaseGridEditLineComponent<InventoryThresholdOverrideAlternative, null, InventoryService> {

    @Input() inventoryReferenceData: InventoryReference
    @Input() inventoryId: string
    searchValue: any;
    searchMergeValue: any;
    searchActive: any;

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);

        this.className = "InventoryThresholdOverrideAlternatives";
        this.appCode = "InventoryThresholdOverrideAlternatives";
        this.saveMode = SaveMode.all;
    }

    searchValueChanged(value: any) {
        this.searchValue = value;
    }

    searchMergeValueChanged(value: any) {
        this.searchMergeValue = value;
    }

    inventorySelected(data: any) {
        if (data != null) {
            if (this.gridData.some(e => e.alternateInventoryId === data.InventoryId)) {
                this.cnfShow("Part Number " + data.Number + " already being used. ", CRUDActions.Cancel, null, "Duplicate Part Number", "DUPALTERNATIVE", true);
                return
            }
            if (this.inventoryId === data.InventoryId) {
                this.cnfShow("Part Number " + data.Number + " is the main part.   ", CRUDActions.Cancel, null, "Part Number Matches Parent ", "DUPALTERNATIVE", true);
                return
            }
            this.selectedData.supplierPartNumbers = data.ManufacturePartNumbers;
            this.selectedData.specifications = data.FullDescription;
            super.inventorySelected(data);
            this.saveLocal(this.selectedData, true);
            this.setDirty();
            this.closeEditor();
            this.sendParentMessage(MessageType.changed);
        } else {
            this.cancelHandler();
        }
    }

    setGridRow(dataItem: InventoryThresholdOverrideAlternative, rowIndex: number) {
        if (CommonFunctions.hasValue(dataItem) && CommonFunctions.hasArrayElementValue(this.gridData, rowIndex)) {
            try {
                this.gridData[rowIndex] = dataItem;
            }
            catch (err) {

            }
        }
    }

    loadData(data: any) {
        this.summary = data.fullDescription;
    }

    createForm() {
        this.editForm = new UntypedFormGroup({
            'primaryInventoryId': new UntypedFormControl(),
            'inventoryAlternativeId' :new UntypedFormControl(),
            'alternateInventoryId' :new UntypedFormControl(),
            'number': new UntypedFormControl(),
            'summary': new UntypedFormControl(),
            'supplierPartNumbers': new UntypedFormControl(),
            'specifications': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl()
        });
    }

    setForm() {
        this.editForm.patchValue({
            primaryInventoryId: this.selectedData.primaryInventoryId,
            inventoryAlternativeId: this.selectedData.inventoryAlternativeId,
            alternateInventoryId: this.selectedData.alternateInventoryId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            number: this.selectedData.number,
            summary: this.selectedData.summary,
            supplierPartNumbers: this.selectedData.supplierPartNumbers,
            specifications: this.selectedData.specifications
        });
    }
    confirmCustom(data: ConfirmOutput) {
        if (data.code === 'DUPALTERNATIVE')
        {
                this.cancelHandler();
        }

    }
}
